// extracted by mini-css-extract-plugin
export var circle = "_2i-2";
export var icon = "_2i-a";
export var iconHighlight = "_2i-0";
export var lg = "_2i-8";
export var md = "_2i-7";
export var outline = "_2i-4";
export var sm = "_2i-6";
export var square = "_2i-1";
export var xl = "_2i-9";
export var xs = "_2i-5";
export var xxs = "_2i-3";